import React from 'react';
import {withRouter} from 'react-router-dom';
import {DataSet, Network} from 'vis-network/standalone/esm/vis-network';
import startPoint from '../../../../images/startPoint.svg'
import endPoint from '../../../../images/endPoint.svg'
import arrowPointer from '../../../../images/down.svg'
import Explorer from "../Explorer";
import appContext from "../../../../context/appContext";
import {nodeShape, nodeShape1, nodeShape2, nodeShape3, nodeShape4, nodeShape5, nodeShapeActive} from './NodeShape'
import {
    nodeShapeCompare11,
    nodeShapeCompare12,
    nodeShapeCompare13,
    nodeShapeCompare14,
    nodeShapeCompare15,
    nodeShapeCompare21,
    nodeShapeCompare22,
    nodeShapeCompare23,
    nodeShapeCompare24,
    nodeShapeCompare25,
    nodeShapeCompare31,
    nodeShapeCompare32,
    nodeShapeCompare33,
    nodeShapeCompare34,
    nodeShapeCompare35,
    nodeShapeCompare41,
    nodeShapeCompare42,
    nodeShapeCompare43,
    nodeShapeCompare44,
    nodeShapeCompare45,
    nodeShapeCompare51,
    nodeShapeCompare52,
    nodeShapeCompare53,
    nodeShapeCompare54,
    nodeShapeCompare55,
    nodeShapeCompare
} from './NodeShapeCompare'
import Loading from "../../../Componnets/Loading";
import GraphNotFound from "./GraphNotFound";
import NodeProfile from "../NodeProfile";
import Export from "../../../Componnets/Export/Export";
import {getCurrentFilters} from "../../../../util/currentFiltersHelper";
import {detectDir} from "../../../../util/util";
import SvgMap from "./SvgMap";
import http from "../../../../services/api/utilities/http";
// import {SaveProcessExplorerState} from "./Graph/SaveState"


// import SvgMap from "./SvgMap";


class Graph extends React.Component {
    static contextType = appContext

    constructor(props) {
        super(props);
        this.state = {
            showProfile: false,
            pos: {x: 0, y: 0},
            index: 0,
            dataGraph: {},
            activities: [],
            countNode: 0,
            edgeIds: [],
            mainEdgeIds: [],
            graph: {nodes: [], edges: []},
            mainVariants: {nodes: [], edges: []},
            noneMainVariants: {nodes: [], edges: []},
            repo: {nodes: [], edges: []},
            variantSelected: [],
            maxEdges: 0,
            view: 'caseCount',
            processCompareView: null,
            views_nodes: null,
            views_edges: null,
            filterDone: false,
            filter: false,
            filterVersion: 0,
            network: null,
            scale: null,
            offsetX: null,
            offsetY: null,
            compareId: null,
            compareColor: '#8A0FFF',
            loading: true,
            svg: true,
            allowChangeColor: false,
            current_activity_count: 0,
            current_edge_count: 0,
            max_activity_count: 0,
            max_edge_count: 0,
            min_activity_count: 0,
            min_edge_count: 0,
            number_of_activities: 0,
            number_of_edges: 0,
            activity_coverage: 0,
            edge_coverage_per_activity: 0,
            edge_coverage_per_event_log: 0,
            actionFilter: false,
            layer1: false,
            layer2: false,
            nodeProfileProcessMapDone: {filters: ''},
            nodeProfileProcessCompareDone: {filters: ''},
            nodeProfileExplorerDone: {filters: ''},
            processCompareSaveVersion: 0,
            successFilterResponse: 'success',
            showGoToDataAnalysisSvg: false,
            isEdgesTouched: false,
            number_of_old_activities: 0,
            number_of_old_activities_auto_save: 0,
            canCall: true,
            forceUpdate: false,
        };
        this.allowUpdateSideBySide = true
        this.domNode = React.createRef();
        this.network = React.createRef();
        this.Viewer = React.createRef();
        this.views = {
            "average": "avg_duration",
            "total": "total_duration",
            "max": "max_duration",
            "min": "min_duration",
            "selfLoops": "self_loop",
            "loop": "loop",
            "caseCount": "case_frequency",
            "totalCount": "total_frequency",
            "totalCost": "total_cost",
            "averageCost": "avg_cost",
        }
    }

    componentDidMount() {
        // SaveProcessExplorerState(this.state.number_of_activities,this.state.number_of_edges)
        // alert(this.showDuration(5555556588))
        // this.context.actionFilter('fetching')
        if (!this.props.statisticalView) {
            this.context.handleCompareId(null)
            this.context.handleCompareColor('#8A0FFF')
        }
        if (this.props.processCompare) {
            this.context.handleCompareId(null)
        }
        if (this.context.handleUid().id) {
            let data = JSON.stringify(this.context.handleUid())
            localStorage.setItem('mapData', data)
            this.getSave()
        } else {
            let data = JSON.parse(localStorage.getItem('mapData'))
            this.context.handleUid(data)
            this.getSave()
        }

        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            this.saveState()
            return null;
        });
    }

    componentDidCatch(error, errorInfo) {
        return 'test'
    }

    allowUpdate = (filter) => {
        if (this.props.compareLayer && this.state.layer2 !== JSON.stringify(filter.layer2_filters)) {
            return true
        } else if (this.props.mainLayer && this.state.layer1 !== JSON.stringify(filter.layer1_filters)) {
            return true
        } else if (!this.props.compareLayer && !this.props.mainLayer) {
            return true
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.location.pathname !== this.props.location.pathname) {
            if (this.context.handleUid().id) {
                let data = JSON.stringify(this.context.handleUid())
                localStorage.setItem('mapData', data)
                this.getSave()
            } else {
                let data = JSON.parse(localStorage.getItem('mapData'))
                this.context.handleUid(data)
                this.getSave(data.id)
            }
        }

        let {processExplorerActiveFilters, processCompareActiveFilters, processMapActiveFilters} = this.context.state
        if (processExplorerActiveFilters?.filters && this.state.nodeProfileExplorerDone !== processExplorerActiveFilters) {
            this.callProcessExplorerApi(this.state.number_of_activities, this.state.number_of_edges)
            this.setState({nodeProfileExplorerDone: processExplorerActiveFilters})
        }

        let view = this.props.processMap ? this.context.view : this.props.processExplorer ? this.context.state.processExplorerView : this.context.processCompareView
        if (this.state.view !== view) {
            this.setState({view})
            if (this.state.view !== '') {
                if (this.state.network) {
                    this.setState({
                        scale: this.state.network.getScale(),
                        offsetX: this.state.network.getViewPosition().x,
                        offsetY: this.state.network.getViewPosition().y,
                    }, () => this.changeView(view))
                } else {
                    this.changeView(view)
                }
            }
        }
        let filter = this.context.selectFilter()
        let diffFilter = JSON.stringify(filter)
        if (this.allowUpdate(filter)) {
            let forceUpdateData = false
            if (this.context.handleLayerList()?.length > 1) {
                if (((this.props.history.location.pathname === "/process-compare" &&
                    JSON.stringify(JSON.parse(prevState.filterDone)?.layer1_filters) !== JSON.stringify(filter.layer1_filters)) ||
                    (this.context.handleLayerList()?.find(item => item.selected)?.type === "mainLayer" && !this.context.handleIsFiltersModalOpen())) && !this.context.handleIsFiltersModalOpen())
                {
                    forceUpdateData = true
                    this.setState({forceUpdate: true})
                    this.context.actionFilter("success")
                } else if (this.props.history.location.pathname === "/process-compare" && this.context.handleLayerList()?.find(item => item.selected)?.type === "mainLayer") {
                    this.context.actionFilter("success")
                }
            }

            if (forceUpdateData || (this.state.actionFilter !== this.context.actionFilter() && this.context.actionFilter() === 'fetching')) {
                this.setState({actionFilter: 'fetching'}, () => {
                    if (this.state.filterDone !== diffFilter) {
                        this.setState({
                            filterDone: diffFilter,
                            layer1: JSON.stringify(filter.layer1_filters),
                            layer2: JSON.stringify(filter.layer2_filters)
                        }, () => {
                            if (this.props.history.location.pathname === '/process-explorer') {
                                this.callProcessExplorerApi()
                            } else {
                                console.log('poooori', filter)
                                if (this.context.handleFiltersSubmitClicked()) {
                                    this.getFilterData(filter.variants)
                                } else {
                                    this.getFilterData()
                                }
                                this.setState({canCall: false})
                            }
                        })
                    } else {
                        this.context.actionFilter(this.state.successFilterResponse)
                        this.setState({actionFilter: this.state.successFilterResponse})
                    }
                })
            }
        }

        if (this.props.location.pathname === '/process-compare' && this.state.compareId !== this.context.handleCompareId() && !this.props.mainLayer) {
            this.setState({
                compareId: this.context.handleCompareId(),
                compareColor: this.context.handleCompareColor(),
                allowChangeColor: false,
            })
            // this.changeView(this.context.view)
            if (this.props.compareLayer)
                this.getSave()
            else if (this.context.handleAutoSave().processCompareVariants) {
                this.getFilterData(this.context.handleAutoSave().processCompareVariants, this.context.handleAutoSave().processCompareFilters, this.context.processCompareView)
            }
        }
        //change color
        setTimeout(() => {
            if (this.props.location.pathname === '/process-compare' && this.state.allowChangeColor && this.state.compareColor !== this.context.handleCompareColor() && !this.props.mainLayer) {
                this.setState({
                    compareColor: this.context.handleCompareColor(),
                    loading: true
                })
                this.changeView()
            }
        }, 100)
        // if( this.props.location.pathname === '/process-compare' && this.state.compareColor !== this.context.handleCompareColor() &&  this.state.compareId !== this.context.handleCompareId() && !this.props.mainLayer){
        //   this.setState({compareColor:this.context.handleCompareColor()})
        //   // this.changeView(this.context.view)
        //   if(this.props.compareLayer)
        //     this.getSave()
        //   else if(this.context.handleAutoSave().processCompareVariants) {
        //     this.getFilterData(this.context.handleAutoSave().processCompareVariants, this.context.handleAutoSave().processCompareFilters, this.context.processCompareView )
        //   }
        // }

        if (this.context.state.processCompareSaveVersion !== this.state.processCompareSaveVersion) {
            this.saveState()
            this.setState({processCompareSaveVersion: this.context.processCompareSaveVersion})
        }
    }

    componentWillUnmount() {
        if (this.state.loading) return
        if (this.props.processExplorer) {
            this.setSaveProcessExplorerState()
        } else if (!this.props.compareLayer) {
            this.saveState()
        }
    }


    getSaveProcessExplorerState() {
        let {id} = this.context.handleUid()
        http.get('process_mining/save_process_explorer_state/' + id)
            .then(res => {
                console.log('get Save', res.data.data)
                let {
                    flow,
                    filters,
                    variants,
                    view,
                    active_variants,
                    number_of_activities,
                    number_of_edges,
                    metrics,
                    min_activity_count,
                    min_edge_count,
                    number_of_old_activities,
                    isEdgesTouched,
                    advanced_activity_filters,
                } = res.data.data.saved_data
                if (filters) this.context.dispatch({type: 'set_process_explorer_filters', value: filters});
                if (variants) this.context.dispatch({type: 'set_process_explorer_variants', value: variants});
                if (active_variants) this.context.dispatch({
                    type: 'set_process_explorer_active_variants',
                    value: active_variants
                });
                if (flow) this.context.dispatch({type: 'set_process_explorer_flow', value: flow});
                if (advanced_activity_filters) this.context.dispatch({type: 'set_process_explorer_advanced_activity_filters', value: advanced_activity_filters});
                if (metrics) this.context.dispatch({type: 'set_process_explorer_metrics', value: metrics});
                if (view) {
                    this.context.dispatch({type: 'set_process_explorer_view', value: view});
                    this.setState({view})
                }
                this.setState({
                    number_of_activities,
                    number_of_edges,
                    min_activity_count,
                    min_edge_count,
                    number_of_old_activities,
                    isEdgesTouched,
                }, () => this.callProcessExplorerApi(number_of_activities, number_of_edges, number_of_old_activities))
            })

    };

    setSaveProcessExplorerState() {
        let {id} = this.context.handleUid()
        http.post('process_mining/save_process_explorer_state/' + id,
            {
                'process_explorer_state': {
                    flow: this.context.state.processExplorerFlow,
                    filters: this.context.state.processExplorerFilters,
                    variants: this.context.state.processExplorerVariants,
                    view: this.context.state.processExplorerView,
                    metrics: this.context.state.processExplorerMetrics,
                    advanced_activity_filters: this.context.state.processExplorerAdvancedActivityFilters,
                    active_variants: this.context.state.processExplorerActiveVariants,
                    number_of_activities: this.state.number_of_activities,
                    number_of_edges: this.state.number_of_edges,
                    number_of_old_activities: this.state.number_of_old_activities_auto_save,
                    min_activity_count: this.state.min_activity_count,
                    min_edge_count: this.state.min_edge_count,
                    isEdgesTouched: this.state.isEdgesTouched,
                },
            })

    };

    saveState = (filters, variants, view = this.context.view) => {
        let metrics = [], flow = []
        if (this.props.mainLayer || this.state.network === null) return;
        let {
            processMapVariants,
            processMapFilters,
            processMapMetrics,
            processCompareVariants,
            processCompareFilters,
            processCompareMetrics,
            processMapAdvancedActivityFilters,
            processMapFlow,
            processCompareFlow
        } = this.context.handleAutoSave();
        if (this.props.processMap) {
            variants = processMapVariants
            filters = processMapFilters
            flow = processMapFlow
        } else {
            view = this.context.processCompareView
            variants = processCompareVariants
            filters = processCompareFilters
            flow = processCompareFlow
        }
        // this.context.dispatch({type:'set_active_variants',value:[]})
        // let id = this.context.handleUid().id
        let id = this.context.handleUid().id
        if (this.props.processMap) {
            http.post('process_mining/save_process_map_state/' + id,
                {
                    'process_map_config': {
                        'filters': filters,
                        'variants': variants,
                        'view': view,
                        'active_variants': this.context.state.activeVariantsProcessMap,
                        'flow': flow,
                        'metrics': processMapMetrics,
                        processMapAdvancedActivityFilters,
                        // 'position': {
                        //   x: this.state.network.getViewPosition().x,
                        //   y: this.state.network.getViewPosition().y,
                        // },
                        // 'scale':this.state.network ? this.state.network.getScale() : false,
                    },
                })
        } else {
            // axios.post('process_mining/save_process_compare_state/' + id,
            //     {
            //         'selected_filters': {
            //             'flow': processCompareFlow,
            //             'filters': filters,
            //             'variants': variants,
            //             'view': view,
            //             'scale': this.state.network ? this.state.network.getScale() : false,
            //             'active_variants': this.context.state.activeVariantsProcessCompare,
            //             'metrics': processCompareMetrics,
            //             'position': {
            //                 x: this.state.network.getViewPosition().x,
            //                 y: this.state.network.getViewPosition().y,
            //             },
            //             'compareId': this.context.handleCompareId()
            //         },
            //     },
            //     {
            //         headers: {
            //             // 'Content-Type':'multipart/form-data',
            //             Authorization: 'Bearer ' + token
            //         }
            //     })
        }

    }
    getSave = (id = this.props.compareLayer ? this.context.handleCompareId() : this.context.handleUid().id) => {
        let {pathname} = this.props.location;
        let {processCompareVariants, processCompqqareFilters} = this.context.handleAutoSave()
        // 9a00e428-d078-4d67-bfd8-c93f78a84343
        if (this.props.processMap) {
            http.get('process_mining/save_process_map_state/' + id)
                .then(res => {
                    // const state = res.data.data.process_map_config;
                    const state = res.data.data.process_map_config;
                    if (state.view) this.context.selectView('/variant-explorer', state.view)
                    else this.context.selectView('/variant-explorer', 'caseCount')

                    // let saveObj = {}
                    // saveObj[this.props.type] =
                    // this.context.handleAutoSave(state)
                    if (this.props.processMap) {
                        if (state.active_variants) this.context.dispatch({
                            type: 'set_active_variants_process_map',
                            value: state.active_variants
                        })
                    }
                    let variants = [1], filters = []
                    if (state.variants && state.variants.length > 0)
                        variants = state.variants
                    if (variants.length > 0)
                        filters = state.filters
                    // if(state.scale && !this.props.compareLayer && !this.props.mainLayer && !this.props.processCompare){
                    //   this.setState({
                    //     scale:state.scale,
                    //     offsetX:state.position.x,
                    //     offsetY:state.position.y,
                    //   },() => this.getFilterData(variants,filters))
                    // }else
                    this.context.handleAutoSave({
                        ...this.context.handleAutoSave(),
                        processMapAdvancedActivityFilters:state.processMapAdvancedActivityFilters,
                        processMapMetrics: state.metrics,
                        processMapFlow: state.flow,
                    });
                    this.getFilterData(variants, filters, state.view, state.active_variants)

                })
                .catch(err => {
                    console.log(err.response)
                    this.setState({loading: false})
                })
        } else if (pathname === '/process-explorer') {
            this.getSaveProcessExplorerState()
        } else if (processCompareVariants) {
            // this.setState({loading: true}, () => this.getFilterData(processCompareVariants, processCompareFilters))
        } else {
            // this.context.actionFilter('fetching')
            //     axios.get('process_mining/save_process_compare_state/' + id,
            //         {
            //             headers: {
            //                 // 'Content-Type':'multipart/form-data',
            //                 Authorization: 'Bearer ' + token
            //             }
            //         })
            //         .then(res => {
            //
            //             let {saved_data} = res.data.data
            //             const state = saved_data
            //             if (state.compareId) {
            //                 this.context.handleCompareId(state.compareId)
            //             }
            //             if (state.active_variants) {
            //                 this.context.dispatch({
            //                     type: 'set_active_variants_process_compare',
            //                     value: state.active_variants
            //                 })
            //             }
            //             //    let {variants,nodes} = filters_result
            //             if (state.view) this.context.selectView('/process-compare', state.view)
            //             else this.context.selectView('/process-compare', 'caseCount')
            //             //   this.context.handleAutoSave({
            //             //     ...this.context.handleAutoSave(),
            //             //     processCompareFilters: state.filters ? state.filters : [],
            //             //     processCompareVariants: state.variants ? state.variants : [1],
            //             //   })
            //             //
            //             // if(nodes)
            //             //   this.context.actionFilter('success')
            //             // this.setState({
            //             //   dataGraph: filters_result,
            //             //   activities: variants[0].variant,
            //             //   lastCount: variants[0].variant.length
            //             // })
            //             // if(this.props.loadMap) this.props.loadMap()
            //             // this.createNodeShape(filters_result)
            //             // if(this.props.processCompare || this.props.statisticalView) {
            //             //   console.log('statical data',{nodes, variants})
            //             //   this.context.handleDataChartCompare({nodes, variants})
            //             // }
            //             let variants = [1], filters = []
            //             if (state.variants && state.variants.length > 0)
            //                 variants = state.variants
            //             if (variants.length > 0)
            //                 filters = state.filters
            //             // if(state.scale && !this.props.compareLayer && !this.props.mainLayer && !this.props.processCompare){
            //             //  console.log('OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO')
            //             //   this.setState({
            //             //     scale:state.scale,
            //             //     offsetX:state.position.x,
            //             //     offsetY:state.position.y,
            //             //   },() => this.getFilterData(variants,filters))
            //             // }else
            //             // if(!this.props.processCompare)
            //             // if(this.context.handleCompareId())
            //             this.context.handleAutoSave({
            //                 ...this.context.handleAutoSave(),
            //                 processCompareMetrics: state.metrics,
            //                 processCompareFlow: state.flow
            //             });
            //             setTimeout(() => this.getFilterData(variants, filters, state.view, state.active_variants), 2000)
            //         })
            //         .catch(err => {
            //             console.log(err.response)
            //             this.context.actionFilter('error')
            //             this.setState({loading: false, actionFilter: 'error', successFilterResponse: 'error'})
            //         })
        }
    }


    getFilterData = (variants = [1], filters = [], view = 'caseCount', active_variants) => {
        // if (this.context.handleUid().id === this.context.handleCompareId()) return
        this.context.actionFilter('fetching')
        let {pathname} = this.props.location
        this.setState({loading: true})
        // eif(!flow)
        // let = this.context.selectFilter()
        let {
            processMapFilters,
            processCompareFilters,
            processMapMetrics,
            processCompareMetrics,
            processMapFlow,
            processCompareFlow,
            processMapAdvancedActivityFilters,
        } = this.context.handleAutoSave();
        if (filters.length === 0) {
            if (pathname === '/variant-explorer') {
                filters = processMapFilters
            } else if (pathname === '/process-explore') {
                filters = this.context.state.processExplorerFilters
            } else if (!this.props.compareLayer) {
                filters = processCompareFilters
            }
        }
        if (!this.props.compareLayer) {
            if (this.props.processMap) {
                view = this.context.view
                this.context.handleAutoSave({
                    ...this.context.handleAutoSave(),
                    processMapFilters: filters,
                    processMapVariants: variants,
                })
            } else {
                view = this.context.processCompareView
                this.context.handleAutoSave({
                    ...this.context.handleAutoSave(),
                    processCompareFilters: filters,
                    processCompareVariants: variants,
                })
            }
        }
        //....
        let token = localStorage.getItem('token')
        let id = this.props.compareLayer ? this.context.handleCompareId() : this.context.handleUid().id
        let process_compare_layer_id = (this.props.processCompare || this.props.statisticalView) ? this.context.handleCompareId() : ''
        // useSWR(['process_mining/filtering/'+id,flow,filters,variants,view,active_variants,process_compare_layer_id],()=>
        //    )
        if (!active_variants) {
            active_variants =
                this.props.processMap ?
                    this.context?.state.activeVariantsProcessMap
                    :
                    this.context?.state.activeVariantsProcessCompare
            if (active_variants?.length === 0 || !active_variants) active_variants = [1]
        }
        if (active_variants.length === 0 || JSON.stringify(variants) === '[1]') {
            active_variants = [1]
        }
        if (active_variants.length !== variants.length) {
            active_variants = variants.map(v => 1)
        }
        let metrics = this.props.processMap || this.props.compareLayer ? processMapMetrics : processCompareMetrics
        let flow = this.props.processMap || this.props.compareLayer ? processMapFlow : processCompareFlow
        let activity_filters = this.props.processMap ? this.context.state.processMapActiveFilters : this.context.state.processCompareActiveFilters
        let advanced_activity_filters = this.props.processMap ? processMapAdvancedActivityFilters : processMapAdvancedActivityFilters
        if (active_variants.length === 0 || JSON.stringify(variants) === '[1]') {
            active_variants = [1]
        }
        let data = {}
        createDataFiltering({
            flow,
            filters,
            variants,
            active_variants,
            process_compare_layer_id,
            metrics,
            activity_filters,
            advanced_activity_filters
        })

        function createDataFiltering(param) {
            let cParam = Object.keys(param)
            cParam.forEach(item => {
                if (param[item] && param[item].length > 0) {
                    data[item] = param[item]
                }
            })
        }

        let url = '/process_mining/variant_explorer/'
        if ((this.props.processCompare || this.props.statisticalView) && process_compare_layer_id) {
            url = 'process_mining/process_compare/'
            // data = this.context.state.processCompare
            data = this.context.selectFilter()
            if (data?.layer1_filters?.filters?.length === 0)
                delete data.layer1_filters['filters']
            if (data?.layer2_filters?.filters?.length === 0)
                delete data.layer2_filters['filters']
        } else if (this.props.processCompare || this.props.mainLayer || this.props.statisticalView) {
            data = this.context.selectFilter().layer1_filters
        } else if (this.props.compareLayer) {
            data = this.context.selectFilter().layer2_filters
        }
        console.log('graph layer', data)
        this.context.handleApiStatusProcessExplorer("loading")


        const force = (pathname === '/process-compare' && !this.context.handleIsFiltersModalOpen()) || this.context.handleLayerList()?.find(item => item.selected)?.type !== "mainLayer"
        if (((this.state.canCall || this.state.forceUpdate) && force) || this.props.processMap) {
            http.post(url + id, data)
                .then(res => {
                    this.context.handleApiStatusProcessExplorer("success")
                    let response = res.data.data
                    let {variants, nodes} = response
                    this.setState({canCall: true})
                    this.setState({forceUpdate: false})

                    if (res.data.Error) {
                        this.context.actionFilter('error')
                        this.setState({loading: false, actionFilter: 'error', successFilterResponse: 'error'})
                    }
                    if (nodes) {
                        this.context.actionFilter('success')
                        this.setState({actionFilter: 'success', successFilterResponse: 'success'})
                    }
                    // else if(filter_results)
                    // this.context.actionFilter('error')

                    this.setState({
                        dataGraph: response,
                        allowChangeColor: true,
                    })

                    if (this.props.loadMap) this.props.loadMap()
                    console.log('test for response', this.props.loadMap, response)
                    this.createNodeShape(response)
                    if (this.props.processCompare || this.props.statisticalView) {
                        this.context.handleDataChartCompare({nodes, variants})
                    }

                })
                .catch(err => {
                    this.context.handleApiStatusProcessExplorer("success")
                    this.setState({canCall: true})
                    console.log('graph errrrrrrrrrrrrrrrrrrrrrrrrr', err)
                    this.context.actionFilter('error')
                    this.setState({loading: false, actionFilter: 'error', successFilterResponse: 'error'})
                    this.setState({forceUpdate: false})
                })


        }

    }


    createNodeShapeCompare = (node, view, color) => {
        let unselected = '', views = this.views,
            name = node.name.substr(0, 28),
            side1 = node.layer1[views[view] ? views[view] : 'duration'],
            side2 = node.layer2[views[view] ? views[view] : 'duration'],
            thickness1 = side1?.thickness || 1,
            thickness2 = side2?.thickness || 1,
            dir = detectDir(name)
        // dir = detectDir(name) === 'ltr'

        console.log(thickness1, thickness2, view)

        if (thickness1 === 1 && thickness2 === 1) unselected = nodeShapeCompare11(name, side1, side2, color, view, dir);
        else if (thickness1 === 1 && thickness2 === 2) unselected = nodeShapeCompare12(name, side1, side2, color, view, dir);
        else if (thickness1 === 1 && thickness2 === 3) unselected = nodeShapeCompare13(name, side1, side2, color, view, dir);
        else if (thickness1 === 1 && thickness2 === 4) unselected = nodeShapeCompare14(name, side1, side2, color, view, dir);
        else if (thickness1 === 1 && thickness2 === 5) unselected = nodeShapeCompare15(name, side1, side2, color, view, dir);
        else if (thickness1 === 2 && thickness2 === 1) unselected = nodeShapeCompare21(name, side1, side2, color, view, dir);
        else if (thickness1 === 2 && thickness2 === 2) unselected = nodeShapeCompare22(name, side1, side2, color, view, dir);
        else if (thickness1 === 2 && thickness2 === 3) unselected = nodeShapeCompare23(name, side1, side2, color, view, dir);
        else if (thickness1 === 2 && thickness2 === 4) unselected = nodeShapeCompare24(name, side1, side2, color, view, dir);
        else if (thickness1 === 2 && thickness2 === 5) unselected = nodeShapeCompare25(name, side1, side2, color, view, dir);
        else if (thickness1 === 3 && thickness2 === 1) unselected = nodeShapeCompare31(name, side1, side2, color, view, dir);
        else if (thickness1 === 3 && thickness2 === 2) unselected = nodeShapeCompare32(name, side1, side2, color, view, dir);
        else if (thickness1 === 3 && thickness2 === 3) unselected = nodeShapeCompare33(name, side1, side2, color, view, dir);
        else if (thickness1 === 3 && thickness2 === 4) unselected = nodeShapeCompare34(name, side1, side2, color, view, dir);
        else if (thickness1 === 3 && thickness2 === 5) unselected = nodeShapeCompare35(name, side1, side2, color, view, dir);
        else if (thickness1 === 4 && thickness2 === 1) unselected = nodeShapeCompare41(name, side1, side2, color, view, dir);
        else if (thickness1 === 4 && thickness2 === 2) unselected = nodeShapeCompare42(name, side1, side2, color, view, dir);
        else if (thickness1 === 4 && thickness2 === 3) unselected = nodeShapeCompare43(name, side1, side2, color, view, dir);
        else if (thickness1 === 4 && thickness2 === 4) unselected = nodeShapeCompare44(name, side1, side2, color, view, dir);
        else if (thickness1 === 4 && thickness2 === 5) unselected = nodeShapeCompare45(name, side1, side2, color, view, dir);
        else if (thickness1 === 5 && thickness2 === 1) unselected = nodeShapeCompare51(name, side1, side2, color, view, dir);
        else if (thickness1 === 5 && thickness2 === 2) unselected = nodeShapeCompare52(name, side1, side2, color, view, dir);
        else if (thickness1 === 5 && thickness2 === 3) unselected = nodeShapeCompare53(name, side1, side2, color, view, dir);
        else if (thickness1 === 5 && thickness2 === 4) unselected = nodeShapeCompare54(name, side1, side2, color, view, dir);
        else if (thickness1 === 5 && thickness2 === 5) unselected = nodeShapeCompare55(name, side1, side2, color, view, dir);
        else unselected = nodeShapeCompare11(name, side1, side2, color, view, dir);
        return unselected
    }

    // a.concat(b.filter((item) => a.indexOf(item) < 0))
    createNodeShape = (res) => {
        // delete res.position
        let nodes = [], graph = [], position = [], color = "#8A0FFF"
        let newNode = [], newEdge = [], unselected = '',
            view = this.props.processMap ? this.context.view : this.props.processExplorer ? this.context.state.processExplorerView : this.context.processCompareView
        if(!view){
            view = 'caseCount'
        }
        if (res) {
            nodes = res.nodes
            graph = res.graph
            position = res.position
        } else {
            let {views_nodes, views_edges, dataGraph} = this.state
            position = dataGraph.position
            nodes = views_nodes
            graph = views_edges
            if (views_nodes === null) return;
        }
        // ${(view === "average" ? "AVG Duration | " + value.avg_duration.value : view === "total" ? "Total Duration | " + value.total_duration.value : view === "max" ? "Max Duration | " + value.max_duration.value : view === "min" ? "Min Duration | " + value.min_duration.value : view === "selfLoops" ? "Self Loop | " + value.self_loop.value : view === "loop" ? "Loop | " + value.loop.value : view === "loop" ? value.case_frequency.value : view === "caseCount" ? "Case Frequency | " + value.case_frequency.value : view === "totalCount" ? "Total Frequency | " + value.total_frequency.value : "Duration | " + value.duration)}
        nodes.forEach(node => {
            if (this.props.compareLayer || node['node_side'] === 'layer2') {
                color = this.context.handleCompareColor()
            } else {
                color = "#8A0FFF"
            }
            // let label = this.views[view].replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase()) +' | '+node[this.views[view]]?.value

            // let label = this.views[view].replace(/_([a-z0-9])/g,/\$1/) +' | '+node[this.views[view]]?.value
            let label = this.views[view].replaceAll('_', ' ') + ' | ' + node[this.views[view]]?.value

            // return
            let name = node.name, dir = detectDir(node.name), id = parseInt(node.id)
            if (node['node_side'] === 'layer1' || node['node_side'] === 'layer2') {
                node = {...node[node['node_side']], name, id}
            }
            if (node['name'] !== '@@S' && node['name'] !== '@@E')
                if ((this.props.processCompare || this.props.statisticalView) && node['node_side'] === 'both' && this.context.handleCompareId() !== this.context.handleUid().id)
                    unselected = this.createNodeShapeCompare(node, view, this.context.handleCompareColor())
                else if (this.calcLevel(node, view) === 1)
                    unselected = nodeShape1(node, name, view, color, dir, label);
                else if (this.calcLevel(node, view) === 2)
                    unselected = nodeShape2(node, name, view, color, dir, label);
                else if (this.calcLevel(node, view) === 3)
                    unselected = nodeShape3(node, name, view, color, dir, label);
                else if (this.calcLevel(node, view) === 4)
                    unselected = nodeShape4(node, name, view, color, dir, label);
                else if (this.calcLevel(node, view) === 5)
                    unselected = nodeShape5(node, name, view, color, dir, label);
                else
                    unselected = nodeShape1(node, name, view, color);
            // selected = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(nodeShapeActive(node, view , color));

            unselected = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(unselected)
            node['x'] = position[id][0]
            node['y'] = position[id][1]

            if (node['name'] === '@@S') {
                node['image'] = startPoint
                node['size'] = 5
            } else if (node['name'] === '@@E') {
                node['image'] = endPoint
                node['size'] = 5
            } else
                node['image'] = {unselected, selected: unselected}

            newNode.push(node)
        })

        graph.forEach(edge => {
            edge['arrows'] = {
                to: {
                    enabled: true,
                    imageHeight: undefined,
                    imageWidth: undefined,
                    // scaleFactor: 0.01,
                    src: arrowPointer,
                    type: "image"
                },
            }
            edge['width'] = edge['value'] * 0.5
            edge['svgWidth'] = edge['value'] && edge['value'] * 0.9
            delete edge['value']
            if (edge.label == 0) {
                delete edge['dashes']
                delete edge['title']
                delete edge['label']
                edge['dashes'] = true
            } else {
                edge['title'] = edge.label
            }
            newEdge.push(edge)

        })
        // if (this.props.variantIndex == 0) {
        this.setState({
            graph: {
                nodes: nodes,
                edges: graph
            },
        })
        this.setState({loading: false}, () => this.drawGraph(newNode, newEdge))
    }

    calcLevel = (value, view) => {
        if (view === 'average')
            return value['avg_duration']['thickness']
        else if (view === 'total')
            return value['total_duration']['thickness']
        else if (view === 'max')
            return value['max_duration']['thickness']
        else if (view === 'SelfLoop')
            return value['self_loop']['thickness']
        else if (view === 'loop')
            return value['loop']['thickness']
        else if (view === 'totalCount')
            return value['total_frequency']['thickness']
        else if (view === 'caseCount')
            return value['case_frequency']['thickness']
        else
            return 1
    }

    changeView = () => {
        this.createNodeShape()
    }

    setVariant = variantSelected => {

        if (this.props.compareLayer || this.props.mainLayer || this.props.processCompare || variantSelected.length === 0) return

        variantSelected = variantSelected.map(select => select.id)
        let activeVariants = variantSelected.map(item => 1)
        this.props.processMap ?
            this.context.dispatch({type: 'set_active_variants_process_map', value: activeVariants})
            :
            this.context.dispatch({type: 'set_active_variants_process_compare', value: activeVariants})

        this.getFilterData(variantSelected, [], 'caseCount', activeVariants)

    }

    drawGraph = (nodes, graph) => {
        this.setState({
            views_nodes: nodes,
            views_edges: graph
        })

        const data = {
            nodes: new DataSet(nodes),
            edges: new DataSet(graph)
        };
        const options = {
            autoResize: true,
            nodes: {
                shape: "image",
                size: 20,
                font: {
                    color: 'white',
                    face: 'Inter',
                    size: 10,
                    strokeWidth: 1,
                    align: 'top'
                },
                color: "#8f93ad",
            },
            edges: {
                physics: true,
                font: {
                    size: 7,
                },
                // :dynamic, continuous, discrete, diagonalCross, straightCross, horizontal, vertical, curvedCW, curvedCCW, cubicBezier
                //discrete//diagonalCross//horizontal//vertical
                smooth: {type: 'continuous'},
                hoverWidth: 1,
            },
            layout: {
                randomSeed: 0.5,
                improvedLayout: true,
                clusterThreshold: 1000,
            },
            // physics: false,
            physics: {
                enabled: false,
            },
            interaction: {
                dragNodes: false,
                hover: true
            },
        }
        let network = new Network(this.domNode.current, data, options);
        this.setState({network})
        network.on('doubleClick', (properties) => {
            console.log('mmm click', properties)
            if (properties.nodes?.length) {
                const node = this.state.dataGraph.nodes.find(node => node.id === properties.nodes[0])
                this.setState({
                    fromNode: undefined,
                    toNode: undefined,
                    node: node.name
                })
            } else {
                const connectedNodes = this.state.dataGraph.graph.find(item => item.id === properties.edges[0])
                const fromNode = this.state.dataGraph.nodes.find(node => node.id === connectedNodes?.from)
                const toNode = this.state.dataGraph.nodes.find(node => node.id === connectedNodes?.to)
                if (fromNode && toNode) {
                    this.setState({
                        fromNode: fromNode.name,
                        toNode: toNode.name,
                        node: undefined
                    })
                }
            }
            if (properties.edges?.length) {
                this.setState({
                    pos: properties.pointer.DOM,
                    showGoToDataAnalysis: true
                })
            } else {
                this.setState({
                    pos: {},
                    showGoToDataAnalysis: false
                })
            }

        })
        network.on('click', function (properties) {
            console.log('seed : ' + network.getSeed())
            if (properties.nodes.length > 0) {
                console.log('mmm click', this.state.dataGraph.nodes_indexs[properties.nodes[0]])
                this.setState({
                    pos: properties.pointer.DOM,
                    index: this.state.dataGraph.nodes_indexs[properties.nodes[0]],
                    showProfile: true,
                    showGoToDataAnalysis: false
                })
            } else {
                this.setState({
                    showProfile: false,
                    showGoToDataAnalysis: false
                })
            }
        }.bind(this));
        network.on('dragEnd', function (params) {
            // console.log('positon', network.getViewPosition())
        });
        network.on('zoom', function (params) {
            // console.log('zoom', network.getScale())
        });

    }

    callProcessExplorerApi = (number_of_activities = 0, number_of_edges = 0, number_of_old_activities = 0) => {
        // this.context.actionFilter('fetching')
        this.context.handleApiStatusProcessExplorer("loading")
        this.setState({loading: true})
        let token = localStorage.getItem('token')
        let id = this.context.handleUid().id
        this.setState({number_of_activities, number_of_edges})
        let data = {}
        createDataFiltering({
            flow: this.context.state.processExplorerFlow,
            filters: this.context.state.processExplorerFilters,
            metrics: this.context.state.processExplorerMetrics,
            advanced_activity_filters: this.context.state.processExplorerAdvancedActivityFilters,
            variants: this.context.state.processExplorerVariants,
            active_variants: this.context.state.processExplorerActiveVariants,
            number_of_activities,
            number_of_edges: this.state.isEdgesTouched ? number_of_edges : 0,
            number_of_old_activities: number_of_edges === 0 ? 0 : number_of_old_activities
        })

        function createDataFiltering(param) {
            let cParam = Object.keys(param)
            cParam.forEach(item => {
                if ((param[item] && param[item].length > 0) || typeof param[item] === 'number') {
                    data[item] = param[item]
                }
            })
        }

        console.log("what I have sent: ", {
            number_of_activities,
            number_of_edges
        })

        http.post('process_mining/process_explorer/' + id,
            data).then(res => {
                this.context.handleFiltersSubmitClicked(false)
                if (res.data.data.error) {
                    this.context.handleApiStatusProcessExplorer("success")
                    this.context.actionFilter('error')
                    this.setState({loading: false, actionFilter: 'error'})
                    return
                }

                this.setState({loading: false})

                let response = res.data.data

                let {nodes, max_activity_count, max_edge_count, min_activity_count, min_edge_count, current_activity_count, current_edge_count, activity_coverage, edge_coverage_per_activity, edge_coverage_per_event_log} = response

                this.setState({max_activity_count, max_edge_count, min_activity_count, min_edge_count, current_activity_count, current_edge_count, activity_coverage, edge_coverage_per_activity, edge_coverage_per_event_log})

                if (!number_of_activities) {
                    this.setState({number_of_activities: min_activity_count})
                }
                if (!number_of_edges) {
                    this.setState({number_of_edges: min_edge_count})
                }

                this.setState({number_of_old_activities: current_activity_count})

                if (nodes) {
                    this.context.actionFilter('success')
                    this.context.handleApiStatusProcessExplorer("success")
                    this.setState({actionFilter: 'success'})
                }

                this.setState({
                    dataGraph: response,
                    allowChangeColor: true,
                })

                if (this.props.loadMap) this.props.loadMap()

                this.createNodeShape(response)

                console.log('max_activity_count', max_activity_count)
            }
        ).catch(er => {
            this.context.handleFiltersSubmitClicked(false)
            this.context.handleApiStatusProcessExplorer("success")
            console.log(er)
            this.context.actionFilter('error')
            this.setState({loading: false, actionFilter: 'error'})
        })
    }
    addActivity = (number_of_activities) => {
        this.setState({
            loading: true,
            number_of_activities,
            number_of_old_activities_auto_save: this.state.isEdgesTouched ? this.state.number_of_old_activities : 0,
        }, () => this.callProcessExplorerApi(number_of_activities, this.state.isEdgesTouched ? this.state.current_edge_count : 0, this.state.isEdgesTouched ? this.state.number_of_old_activities : 0))
    }
    addEdge = (number_of_edges) => {
        let isEdgesTouched = this.state.isEdgesTouched
        if (number_of_edges === this.state.min_edge_count) {
            isEdgesTouched = false
            this.setState({isEdgesTouched})
        }
        this.setState({
            loading: true,
            number_of_edges,
            number_of_old_activities_auto_save: isEdgesTouched ? this.state.number_of_old_activities : 0,
        }, () => this.callProcessExplorerApi(this.state.current_activity_count, isEdgesTouched ? number_of_edges : 0, isEdgesTouched ? this.state.number_of_activities : 0))
    }

    handleRedirectToShowBpmn = () => {
        const {history} = this.props;
        history.push('/show-generated-bpmn');
    }

    handleGoToDataAnalysis = () => {
        console.log('filter go to data',getCurrentFilters(this.context, this.props.history.location.pathname))
        const filters = {
            currentFilters: getCurrentFilters(this.context, this.props.history.location.pathname),
            newFlowSelection: {
                fromNode: this.state.fromNode,
                toNode: this.state.toNode,
                node: this.state.node,
            }
        }

        this.context.handleOverrideDataAnalysisFilters(filters)
        const {history} = this.props;
        history.push('/data-analysis');
        this.context.handleAddTab(4, 'Data Analysis', 'data-analysis');
    }

    dbClickOnSvgMap = (properties) => {
        console.log('mmm click', properties)
        if (properties.nodes?.length) {
            const node = this.state.dataGraph.nodes.find(node => node.id === properties.nodes[0])
            this.setState({
                fromNode: undefined,
                toNode: undefined,
                node: node.name
            })
        } else {
            const connectedNodes = this.state.dataGraph.graph.find(item => item.id === properties.edges[0])
            const fromNode = this.state.dataGraph.nodes.find(node => node.id === connectedNodes?.from)
            const toNode = this.state.dataGraph.nodes.find(node => node.id === connectedNodes?.to)
            if (fromNode && toNode) {
                this.setState({
                    fromNode: fromNode.name,
                    toNode: toNode.name,
                    node: undefined
                })
            }
        }
        this.setState({
            pos: properties.pos,
            showGoToDataAnalysisSvg: true
        })

    }

    render() {
        const {
            showProfile,
            number_of_activities,
            number_of_edges,
            index,
            dataGraph,
            graph,
            loading,
            views_nodes,
            max_activity_count,
            max_edge_count,
            min_activity_count,
            min_edge_count,
            current_activity_count,
            current_edge_count,
            activity_coverage,
            edge_coverage_per_activity,
            edge_coverage_per_event_log,
        } = this.state;
        const {history} = this.props;

        return (
            <>
                {
                    loading ?
                        <Loading/>
                        :
                        this.context.actionFilter() === 'error' ?
                            <GraphNotFound/>
                            :
                            <>
                                <div
                                    className={`process__map d-none ${(this.props.processMap || this.props.processExplorer) && 'process__map__position'}`}
                                    id={(this.props.processMap || this.props.processExplorer || this.props.processCompare) ? 'mynetwork' : this.props.statisticalView ? 'staticView' : ''}
                                    ref={this.domNode}/>
                                {(this.state.dataGraph.nodes) &&
                                <SvgMap
                                    dbClick={this.dbClickOnSvgMap}
                                    closeProfile={() => this.setState({
                                        showProfile: false,
                                    })}
                                    showProfile={node => this.setState({
                                        index: node,
                                        showProfile: true,
                                        showGoToDataAnalysis: false
                                    })}
                                    views={this.views}
                                    Viewer={this.Viewer}
                                    goToDataAnalysis={this.handleGoToDataAnalysis}
                                    showGoToDataAnalysis={this.state.showGoToDataAnalysisSvg}
                                    goToDataAnalysisPos={this.state.pos}
                                    view={this.props.processMap ? this.context.view : this.props.processExplorer ? this.context.state.processExplorerView : this.context.processCompareView}
                                    closeGoToDataAnalysis={() => this.setState({showGoToDataAnalysisSvg: false})}
                                    data={this.state.dataGraph}
                                    compareLayer={this.props.compareLayer}
                                    mainLayer={this.props.mainLayer}
                                    color={this.context.handleCompareColor()}
                                    statisticalView={this.props.statisticalView}
                                />

                                }
                            </>
                }
                <div style={{position: 'absolute', top: 16, right: history.location.pathname === "/variant-explorer" ? 0 : history.location.search === "?view=side-by-side" ? 24 : 12, zIndex: 0}}>
                    {/*<button id={"printButton"} onClick={() => printDiv()}>*/}
                    {/*    <i>*/}
                    {/*        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                    {/*            <path d="M12.1222 15.4361L12.1222 3.3951" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>*/}
                    {/*            <path d="M15.0382 12.5084L12.1222 15.4364L9.20619 12.5084" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>*/}
                    {/*            <path d="M16.755 8.12799H17.688C19.723 8.12799 21.372 9.77699 21.372 11.813V16.697C21.372 18.727 19.727 20.372 17.697 20.372L6.55699 20.372C4.52199 20.372 2.87199 18.722 2.87199 16.687V11.802C2.87199 9.77299 4.51799 8.12799 6.54699 8.12799L7.48899 8.12799" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>*/}
                    {/*        </svg>*/}
                    {/*    </i>*/}
                    {/*</button>*/}
                    {showProfile && history.location.search !== "?view=side-by-side" && history.location.search !== "?view=statistical-view" &&
                    <div className="node-profile">
                        <NodeProfile
                            closeProfile={() => this.setState({
                                showProfile: false,
                            })}
                            index={index}
                            data={views_nodes}
                            dataGraph={dataGraph}
                            showNodeProfile={this.state.showProfile}
                        />
                    </div>
                    }
                    {
                        this.state.showGoToDataAnalysis &&
                        <div className={"goToDataAnalysisButton"}
                             style={{top: this.state.pos.y + 110, left: this.state.pos.x + 60}}
                             onClick={this.handleGoToDataAnalysis}>
                            <div>
                                Go to data analysis
                            </div>
                            <div className={"d-flex align-items-center"}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.375 3.75L11.625 9L6.375 14.25" stroke="#0A195C" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    }
                    <div style={{position: "fixed", top: 238, left: 30}}>
                        <Export Viewer={this.Viewer}/>
                    </div>
                    {
                        !this.props.conformanceChecking && !this.props.notShowHandler &&
                        (dataGraph.variants && graph.nodes.length > 0) &&
                        <Explorer
                            setVariantIndex={this.setVariant}
                            variants={dataGraph.variants}
                            currentActivityCount={current_activity_count}
                            maxActivityCount={max_activity_count}
                            minActivityCount={min_activity_count}
                            currentEdgeCount={current_edge_count}
                            minEdgeCount={min_edge_count}
                            maxEdgeCount={max_edge_count}
                            numberOfActivities={number_of_activities}
                            numberOfEdges={number_of_edges}
                            edgeCoveragePerActivity={edge_coverage_per_activity}
                            edgeCoveragePerEventLog={edge_coverage_per_event_log}
                            activityCoverage={activity_coverage}
                            handleActivity={this.addActivity}
                            handleEdge={this.addEdge}
                            callProcessExplorerApi={this.callProcessExplorerApi}
                            type={this.props.type}
                            onEdgesTouched={() => this.setState({isEdgesTouched: true})}
                            isEdgesTouched={this.state.isEdgesTouched}
                        />
                    }
                </div>
            </>
        );
    }

}

export default withRouter(Graph);
